"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Link_1 = require("@idp/ui-components/components/atoms/Link");
/** Stylesheets */
var globalStyles = require("../../../styles/att-global.scss");
var styles = require("./UnauthenticatedPaymentsLink.scss");
var ReportingService_1 = require("../../../api/ReportingService");
var UnauthenticatedPaymentsLink = /** @class */ (function (_super) {
    __extends(UnauthenticatedPaymentsLink, _super);
    function UnauthenticatedPaymentsLink(props) {
        var _this = _super.call(this, props) || this;
        _this.initializeEvents();
        return _this;
    }
    UnauthenticatedPaymentsLink.prototype.initializeEvents = function () {
        var _this = this;
        this.events = {
            onClick: function () {
                console.log('fire');
                _this.reportingService = new ReportingService_1.default();
                _this.reportingService
                    .analyticsLoginPageLoad('isLoginPageLoadedAlready', ReportingService_1.PageUrls.LOGIN_PAGE, ReportingService_1.PageName.LOGIN_PAGE);
                _this.reportingService.fireLinkClickEvent(ReportingService_1.LoginLinkNames.UNAUTH_PAYMENTS_CONTNUE_WITHOUT_SIGNING_IN, _this.props.data.loginUrl);
            },
        };
    };
    UnauthenticatedPaymentsLink.prototype.render = function () {
        return (React.createElement("div", { className: [styles.continueWithoutSignin].join(' ') },
            React.createElement("div", { className: [globalStyles.formRowMd, globalStyles.textCenter].join(' ') },
                React.createElement("div", null, "Just need to make a payment?"),
                React.createElement(Link_1.default, { data: {
                        content: 'Continue without signing in',
                        href: 'https://www.att.com/acctmgmt/fastpay',
                    }, events: this.events, testId: 'LoginWidget_Link_Payment_Continue_Without_Sign' }))));
    };
    return UnauthenticatedPaymentsLink;
}(React.Component));
exports.default = UnauthenticatedPaymentsLink;
//# sourceMappingURL=UnauthenticatedPaymentsLink.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/common/UnauthenticatedPaymentsLink/UnauthenticatedPaymentsLink.js
// module id = 590
// module chunks = 8